import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/styles';
import Location from '../../Location';
import QuestionTitle from './QuestionTitle';
import QuestionSubTitle from './QuestionSubTitle';

const useStyles = makeStyles(() => ({
  optionSelectRoot: {
    margin: '30px 0 10px',
    maxWidth: ({ provider }) => (provider ? 'unset' : 450),
    minHeight: 400,
  },
}));

const LocationQuestion = ({ question, onChange }) => {
  const { id, title, subtitle } = question;
  const { appConfiguration: { providerSpecific } = {} } = useSelector((state) => state) ?? {};
  const classes = useStyles({ provider: providerSpecific?.code });

  return (
    <Grid key={id}>
      <QuestionTitle label={title} />

      {subtitle && <QuestionSubTitle label={subtitle} />}

      <Location item={question} rootClassName={classes.optionSelectRoot} onChange={onChange} />
    </Grid>
  );
};

LocationQuestion.propTypes = {
  /**
   * Question object with title, subtitles, etc
   */
  question: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default LocationQuestion;
